import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonTextForOctopusCli, CommonBuildServerPackagingTextForIntegration } from "../CommonRegistrationText";
const BuildServerPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging other applications from build servers, we recommend using the <ExternalLink href={"cli"}>Octopus CLI</ExternalLink>.
        </p>
        {CommonTextForOctopusCli}
        {CommonBuildServerPackagingTextForIntegration}
    </div>);
BuildServerPackaging.displayName = "BuildServerPackaging"
export default buildServerPackagingInstruction(() => <BuildServerPackaging />);
